const toShippingTypes = (serverProductType) => {
  switch (serverProductType) {
    case "CONTACT_LENSES":
      return "CONTACT_LENSES";
    case "FRAMES":
      return "GLASSES_BUNDLE";
    case "NON_PRESCRIPTION_BUNDLE":
      return "NON_PRESCRIPTION_BUNDLE";
    case "ACCESSORIES":
    case "SOLUTIONS":
      return "REGULAR";
    case "SUNGLASSES":
      return "SUNGLASSES";
    default:
      return void 0;
  }
};
export {
  toShippingTypes
};
//# sourceMappingURL=map-product-to-shipping-types.js.map
